import { combineReducers } from "redux"

// Layout
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"

// Profile
import Profile from "./auth/profile/reducer"

// Files
import Files from "./files/reducer"

const rootReducer = combineReducers({
  Layout,
  Login,
  Profile,
  Files
})

export default rootReducer
